import { AfterViewChecked, Component, ElementRef, Renderer2, computed, inject, input, signal, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NoOpLink } from "@kno2/common/directives";
import { UserProfileOrganization } from "@kno2/core/session/user-profile.model";
import { OrgSwitcherMode, OrgSwitcherService } from "./org-switcher.service";

@Component({
    selector: "kno2-org-switcher",
    imports: [FormsModule, NoOpLink],
    templateUrl: "./org-switcher.component.html",
    styles: `
        .dropdown-menu li.disabled > a:hover,
        .dropdown-menu li.disabled > a:focus {
            color: #999999 !important;
            background: transparent;
        }
    `
})
export class OrgSwitcherComponent implements AfterViewChecked {
    private readonly orgSwitcherService = inject(OrgSwitcherService);
    private readonly renderer = inject(Renderer2);

    private orgToggleDropdown = viewChild<ElementRef>("orgToggleDropdown");
    private orgToggleSearch = viewChild<ElementRef>("orgToggleSearch");

    protected organizationName = input.required<string>();
    protected organizations = input.required<UserProfileOrganization[]>();
    protected filteredOrganizations = computed(() =>
        this.organizations()
            .filter((org) => org.name.toLowerCase().includes(this.search().toLowerCase()))
            .map((org) => {
                const switchMode = this.orgSwitcherService.modeFor(org);
                return { ...org, switchMode, isDisabled: switchMode === "unavailable" || (!org.isActivated && org.role === "User") };
            })
            .sort((a, b) => a.name.localeCompare(b.name))
    );

    public search = signal<string>("");

    public ngAfterViewChecked(): void {
        if (this.orgToggleSearch && this.orgToggleSearch().nativeElement) {
            const elementStyle = window.getComputedStyle(this.orgToggleSearch().nativeElement);
            if (elementStyle && elementStyle.display !== "none" && elementStyle.visibility !== "hidden") {
                this.orgToggleSearch().nativeElement.focus();
            }
        }
    }

    public async changeOrganization(org: UserProfileOrganization & { switchMode: OrgSwitcherMode }): Promise<void> {
        if (org.switchMode === "unavailable") {
            return;
        }

        this.renderer.removeClass(this.orgToggleDropdown().nativeElement, "show");
        if (org.switchMode === "signIn") {
            await this.orgSwitcherService.signInTo(org);
        } else {
            await this.orgSwitcherService.switchSilently(org);
        }
    }
}
